import React, {useContext, useEffect, useRef, useState} from 'react';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './styles.scss';
import { AmplifyAuthenticator } from '@aws-amplify/ui-react';
import {Auth} from "aws-amplify";
import { useHistory } from 'react-router-dom';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import { IdentityContext, IdentityDispatchContext, IdentityProvider } from "./context/identity-context";
import DefaultLayout from "./layouts/DefaultLayout";
import ClientLayout from "./layouts/ClientLayout";
import CustomForgotPassword from "./components/custom-forgot-password/custom-forgot-password";
import CustomLogin from "./components/custom-login/custom-login";
import UserService from "./services/user-service";
import CustomSignUp from "./components/CustomSignUp";
import Invest from './pages/invest/invest';
import {cognitoSignOut, getAuthenticatedRole} from "./helpr/authHelper";
import CustomConfirmSignIn from "./components/custom-confirm-signin/custom-confirm-signin";
import PrivacyNotice from "./pages/public/privacy-notice/privacy-notice";
import IdleTimer from 'react-idle-timer'
import ModalCustom from "./components/modal/modal";
import genericModalStyle from "./components/modal/modal.module.scss"
import IdleSessionModalContent from "./pages/general/idle-session-modal-content/idle-session-modal-content";
import TermsConditions from "./pages/public/terms-conditions/terms-conditions";
import AnnouncementSection from "./pages/public/announcements/announcements";

/*
  SecureApp - component that enforces authorization and retrieves
  authenticated user and its access rights
 */
const SecureApp = ({showIdle}) => {
  /*
    Page History for page routes on signout
  */
  const history = useHistory();
  /*
    Use and define security context for authorization
   */
  const { authState, user, modules, role } = useContext(IdentityContext)
  /*
    Dispatcher methods for identity context
   */
  const { setAuthState, setUser, setInitialUser, setModules, setRole, clearIdentityContext } = useContext(IdentityDispatchContext)

  /*
    Idle timeout
   */
  const TIMEOUT_MINUTES = 15;
  const [timeoutDuration, setTimeoutDuration] = useState(1000 * 60 * TIMEOUT_MINUTES);
  const [isTimedOut, setIsTimedOut] = useState(false);
  const idleTimer = useRef();
  const onAction = async () => {
    try {
      const session =  await Auth.currentSession()
      setIsTimedOut(false);
    } catch(error){
      await forceSignOut()
      // showIdle();
    }
  }

  const onActive = async (e) => {
    try {
      const session =  await Auth.currentSession()
      setIsTimedOut(false);
    } catch(error){
      await forceSignOut()
      // showIdle();
    }
  }

  const onIdle = async (e) => {
    if (!isTimedOut) {
      idleTimer.current.reset();
      setIsTimedOut(true);
      await forceSignOut()
      showIdle();
    }
  }

  const forceSignOut = async() => {
    try {
      console.log('Signing out...');
      await cognitoSignOut();
      history.replace('/');
      localStorage.clear();
      clearIdentityContext();
    } catch (error) {
      console.log('error signing out:', error.message);
    }
  }
  /*
    Set auth state, authorized user information, and access rights
    on sign in state and component cleanup
   */
  useEffect(() => {
    /*
      Triggers when auth state changes
     */
    return onAuthUIStateChange(async (nextAuthState, authData) => {
      console.log("Auth state changed...", nextAuthState);
      setAuthState(nextAuthState);
      /*
        Retrieve user access rights
       */
      if (nextAuthState === AuthState.SignedIn && authData) {
        setUser(authData);
        console.log("Retrieving user modules...", authData)
        const role = getAuthenticatedRole(authData);
        setRole(role);
        const userService = new UserService();
        const modules = await userService.getUserModules(role, authData);
        console.log(modules);
        setModules(modules);

      }
      if (nextAuthState === AuthState.ConfirmSignIn) {
        setInitialUser(authData);
      }
    });
    // eslint-disable-next-line
  }, []);

  /*
    JSX Markup that enforces authentication if state is not
    signed in otherwise redirects to default layout component
   */
  return authState === AuthState.SignedIn && user ? (
    <Switch>
      <Route path="/">
        <IdleTimer
          ref={idleTimer}
          element={document}
          onActive={onActive}
          onIdle={onIdle}
          onAction={onAction}
          debounce={250}
          timeout={timeoutDuration} />
        <DefaultLayout user={user} role={role} modules={modules}  />
      </Route>
    </Switch>
  ) : (
    <AmplifyAuthenticator >
      <CustomLogin />
      <CustomConfirmSignIn />
      <CustomForgotPassword />
      {/*<CustomSignUp />*/}
    </AmplifyAuthenticator>
  );
}

/*
  App - main app component with identity provider for
  auth state, user and access rights information
 */
const App = () => {
  const [show, setShow] = useState(false);
  return (
    <Router>
      <Switch>
        <Route exact path="/client">
          <ClientLayout modules={[{
            path: '/client', name: 'Client', component: Invest, link: false
          }]}/>
        </Route>
        <Route exact path="/privacy-notice">
          <ClientLayout modules={[{
            path: '/privacy-notice', name: 'Privacy Notice', component: PrivacyNotice, link: false
          }]}/>
        </Route>
        <Route exact path="/terms-conditions">
          <ClientLayout modules={[{
            path: '/terms-conditions', name: 'Terms and Conditions', component: TermsConditions, link: false
          }]}/>
        </Route>
        <Route exact path="/announcements">
          <ClientLayout navheader="LIST OF SELLING AGENTS FOR ONGOING ISSUANCES" modules={[{
            path: '/announcements', name: 'Announcement Section', component: AnnouncementSection, link: false
          }]}/>
        </Route>
        <Route>
          <IdentityProvider>
            <SecureApp showIdle={()=>setShow(true)}/>
            <ModalCustom
              show={show}
              title={''}
              onClose={() => setShow(false)}
              component={<IdleSessionModalContent onClose={() => setShow(false)} />}
              style={genericModalStyle['generic']} />
          </IdentityProvider>
        </Route>
      </Switch>
    </Router>
  );
}

export default App



